<template>
  <div>
    <div
      class="kingster-page-title-wrap  kingster-style-medium kingster-left-align"
      :style="
        'background-image: url(' +
          require('@/assets/images/template4/page-title.jpg') +
          ')'
      "
    >
      <div class="kingster-header-transparent-substitute"></div>
      <div class="kingster-page-title-overlay"></div>
      <div class="kingster-page-title-container kingster-container">
        <div class="kingster-page-title-content kingster-item-pdlr">
          <div class="kingster-page-caption">Tim Kami</div>
          <h1 class="kingster-page-title">{{ meta.name }}</h1>
        </div>
      </div>
    </div>
    <div class="kingster-breadcrumbs">
      <div class="kingster-breadcrumbs-container kingster-container">
        <div class="kingster-breadcrumbs-item kingster-item-pdlr">
          <span property="itemListElement" typeof="ListItem"
            ><router-link
              :to="`/${meta.preview}`"
              property="item"
              typeof="WebPage"
              title="Go to Kingster."
              class="home"
              ><span property="name">Home</span></router-link
            >
            <meta property="position" content="1" /> </span
          >&gt;<span property="itemListElement" typeof="ListItem"
            ><span property="name"> Tim Kami </span>
            <meta property="position" content="2" />
          </span>
        </div>
      </div>
    </div>
    <div class="kingster-page-wrapper" id="kingster-page-wrapper">
      <div class="gdlr-core-page-builder-body">
        <div class="gdlr-core-pbf-section">
          <div
            class="gdlr-core-pbf-section-container gdlr-core-container clearfix"
          >
            <div class="gdlr-core-pbf-element">
              <div
                class="gdlr-core-blog-item gdlr-core-item-pdb clearfix  gdlr-core-style-blog-image"
                style="padding-bottom: 40px ;"
              >
                <div class="gdlr-core-blog-item-holder gdlr-core-js-2 clearfix">
                  <div
                    class="gdlr-core-item-list  gdlr-core-item-pdlr gdlr-core-item-mgb gdlr-core-column-15"
                    v-for="(org, index) in organization"
                    :key="`org_${index}`"
                    data-aos="zoom-in"
                    :data-aos-duration="index + `000`"
                    :data-aos-delay="index + `00`"
                  >
                    <div
                      class="gdlr-core-blog-modern  gdlr-core-with-image gdlr-core-hover-overlay-content gdlr-core-opacity-on-hover gdlr-core-zoom-on-hover"
                    >
                      <div class="gdlr-core-blog-modern-inner">
                        <div
                          class="gdlr-core-blog-thumbnail gdlr-core-media-image"
                        >
                          <img
                            class="img-fluid img-teacher"
                            :src="org.image"
                            width="700"
                            height="660"
                            alt=""
                          />
                        </div>
                        <div
                          class="gdlr-core-blog-modern-content  gdlr-core-center-align"
                        >
                          <h3
                            class="gdlr-core-blog-title gdlr-core-skin-title"
                            style="font-size: 22px ;font-weight: 700 ;letter-spacing: 0px ;"
                          >
                            <a href="#">{{ org.title }}</a>
                          </h3>
                          <div
                            class="gdlr-core-blog-info-wrapper gdlr-core-skin-divider"
                          >
                            <!-- <span
                              class="gdlr-core-blog-info gdlr-core-blog-info-font gdlr-core-skin-caption gdlr-core-blog-info-date"
                              ><a href="#">June 6, 2016</a></span
                            > -->
                            <span
                              class="gdlr-core-blog-info gdlr-core-blog-info-font gdlr-core-skin-caption gdlr-core-blog-info-author"
                            >
                              <a
                                href="#"
                                title="Posts by John Smith"
                                rel="author"
                                >{{ org.body }}</a
                              ></span
                            >
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <!-- <div
                  class="gdlr-core-load-more-wrap gdlr-core-js gdlr-core-center-align gdlr-core-item-pdlr"
                >
                  <a href="#" class="gdlr-core-load-more gdlr-core-button-color"
                    >Load More</a
                  >
                </div> -->
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: ["organization", "meta"],
};
</script>
